export default "__VITE_ASSET__ab15f3cf__"